module.exports = __webpack_public_path__ + "static/media/website-friend.e6c4d3d7.png";